"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLetters = void 0;
function toLetters(num) {
    var mod = num % 26;
    var pow = (num / 26) | 0;
    var out = mod ? String.fromCharCode(64 + mod) : (--pow, 'Z');
    return pow ? toLetters(pow) + out : out;
}
exports.toLetters = toLetters;
//# sourceMappingURL=StringUtils.js.map